import React from "react";
import { useQuery } from "react-query";

import { PROFILE } from "app/api/ApiEndpoints";
import { StoreContext } from "app/context/Store";
import Widget from "app/components/widget/Widget";
import { useGet } from "app/services/http-service";
import { SELECTED_CATEGORY } from "app/context/Types";
import PageWrapper from "app/components/page-wrapper/PageWrapper";
import ContactList from "app/components/contact-list/ContactList";

function MobileRecharge(props) {
  const mobileRechargeCategory = props?.match?.params?.category;
  const context = React.useContext(StoreContext);
  const authToken = localStorage.getItem("tspAuthToken");
  const [step, setStep] = React.useState(1);

  /* Todo: Bind Recent Recharge api here */
  const { data: userProfileData } = useQuery("fetchProfile", () =>
    useGet({ url: PROFILE, token: authToken }),
  );

  const changeStep = (val) => {
    setStep(val);
  };

  React.useEffect(() => {
    if (mobileRechargeCategory) {
      context.dispatch({
        type: SELECTED_CATEGORY,
        payload: { ...context.state, selectedCategory: mobileRechargeCategory },
      });
    }
  }, [mobileRechargeCategory]);

  return (
    <PageWrapper title="Recharge">
      <div className="row my-4 pay-bills">
        <div className="col-md-3 col-12">
          <Widget
            step={step}
            changeStep={changeStep}
            selectedCategory={mobileRechargeCategory}
          />
        </div>
        <div className="col-md-8 col-12">
          <div className="position_relative">
            <div className="widget-insurance">
              <ContactList
                changeStep={changeStep}
                userProfileData={userProfileData}
              />
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

export default MobileRecharge;
